// Copyright 1999-2022. Plesk International GmbH. All rights reserved.

import Vue from "vue";
import Vuex from "vuex";
import { db } from "../firebase";
import notification from "./notificacion";
import trazabilidad from "./trazabilidad";
import seguroTercero from "./seguroTercero";
import { getAuth, signOut } from "firebase/auth";
// import router from "@/routes/Routes";

Vue.use(Vuex);

export default new Vuex.Store({
  namespace: true,
  state: {
    drawer: false,
    user: null,
    logged: false,
    cliente: null,
    logueado: {},
    gps: true,
    estadoUsuario: [
      {
        title: "Activo en espera",
        value: "Activo en espera",
        color: "success",
      },
      {
        title: "Activo ocupado",
        value: "Activo ocupado",
        color: "warning",
      },
      {
        title: "Activo multiple",
        value: "Activo multiple",
        color: "white",
      },
      {
        title: "Ausente",
        value: "Fuera de su horario laboral",
        color: "red",
      },
      {
        title: "Cancelado",
        value: "Cancelado",
        color: "grey",
      },
    ],
  },
  mutations: {
    toggleDrawer(state) {
      state.drawer = !state.drawer;
    },
    setUser(state, payload) {
      state.user = payload.id;
      state.logged = true;
    },
    setCliente(state, payload) {
      state.cliente = payload.id;
      state.logged = true;
    },
    authData(state) {
      if (state.logged) {
        return;
      }

      if (localStorage.getItem("cliente")) {
        state.cliente = localStorage.getItem("cliente");
        state.logged = true;
      }

      if (localStorage.getItem("user")) {
        state.user = localStorage.getItem("user");
        try {
          const raw = localStorage.getItem("logueado");
          const parsed = raw ? JSON.parse(raw) : null;
          state.logueado = parsed && typeof parsed === "object" ? parsed : {};
        } catch (e) {
          state.logueado = {};
        }
        state.logged = true;
      }
    },
    salir(state) {
      const auth = getAuth();
      signOut(auth)
        .then(() => {
          localStorage.removeItem("id");
          localStorage.removeItem("logueado");
          localStorage.removeItem("user");
          localStorage.removeItem("cliente");
          localStorage.removeItem("tokenSegurosTerceros");
          state.logged = false;
          state.user = null;
          state.cliente = null;
          state.logueado = {};
          // if (router.app._route.path !== "/login") {
          //   router.push("/login");
          // }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    salirCliente(state) {
      localStorage.removeItem("id");
      localStorage.removeItem("user");
      localStorage.removeItem("cliente");
      localStorage.removeItem("logueado");
      state.logged = false;
      state.cliente = null;
      state.logueado = {};
      return;
    },
    logueado(state, payload) {
      state.logueado = payload;
    },
    setGps(state, payload) {
      state.gps = payload;
    },
    SetInfoUsuario(state, payload) {
      state.logueado = payload;
    },
  },
  actions: {
    TOGGLE_DRAWER({ commit }) {
      commit("toggleDrawer");
    },
    signUserIn({ commit }, payload) {
      db.collection("usuarios")
        .where("uiid", "==", payload.id)
        .get()
        .then((querySnapshot) => {
          const logueado = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          localStorage.setItem("logueado", JSON.stringify(logueado[0]));
          commit("logueado", logueado[0]);
        })
        .catch((e) => {
          console.log(e);
        });
      commit("setUser", payload);
    },
    updatePerfilLogueado({ commit }, payload) {
      db.collection("usuarios")
        .doc(payload.id)
        .get()
        .then((result) => {
          const obj = { ...result.data(), id: payload.id };
          localStorage.setItem("logueado", JSON.stringify(obj));
          commit("logueado", obj);
        });
    },
    // eslint-disable-next-line no-unused-vars
    async trazabilidadCaso({ commit }, payload) {
      try {
        await db
          .collection("trazabilidad")
          .add({ ...payload, fechahora: Date.now() });
      } catch (error) {
        console.log(error);
      }
    },
    async trazabilidadEstadoUsuarios(context, payload) {
      try {
        console.log(context);
        await db.collection("trazabilidadestado").add({
          ...payload,
          fechahora: Date.now(),
        });
      } catch (error) {
        console.log(error);
      }
    },
    signClienteIn({ commit }, payload) {
      commit("setCliente", payload);
    },
    actionGps({ commit }, payload) {
      commit("setGps", payload);
    },
    // eslint-disable-next-line no-unused-vars
    async ActualizarLoginUsuario({ commit }, payload) {
      if (payload) {
        const { id } = payload;
        delete payload.id;
        delete payload.salir;
        await db
          .collection("usuarios")
          .doc(id)
          .update({
            ...payload,
          });
      }
    },

    // eslint-disable-next-line no-unused-vars
    async ActualizarLoginCliente({ commit }, payload) {
      if (payload) {
        await db.collection("casos").doc(payload.id).update({
          login: payload.login,
        });
      }
    },

    // eslint-disable-next-line no-unused-vars
    async ConsultarInfoUsuario({ commit }, payload) {
      if (payload) {
        const usuario = await db.collection("usuarios").doc(payload.id).get();
        commit("SetInfoUsuario", usuario.data());
      }
    },
  },
  getters: {
    DRAWER_STATE(state) {
      return state.drawer;
    },
    user(state) {
      return state.user;
    },
    cliente(state) {
      return state.cliente;
    },
    logged(state) {
      return state.logged;
    },
    getGps(state) {
      return state.gps;
    },
    getLogueado(state) {
      return state.logueado;
    },
  },
  modules: {
    notification,
    seguroTercero,
    trazabilidad,
  },
});
